






























import Vue from "vue";
import DashboardCard from "./DashboardCard.vue";
import { getAPI, getStorageData } from "../../util";

export default Vue.extend({
  components: {
    DashboardCard,
  },
  data() {
    return {
		autoRefresh: true,
		interval: null,
		timeInterval: 30000,
		lastId: 0,
		limit: 50,
		offset: 0,
		userRole: null,
		loading: true,
		audio: null,
    };
  },
	beforeMount(){
		const user = getStorageData('user');
		if(user == null) {
			this.$router.replace("/login");
			return;
		} else {
			this.userRole = user['role'];
			this.refreshData();

			const interval = setInterval(async () => {
				if(this.autoRefresh) { 
					// console.log("Order::componentDidMount() - refreshData being called....");
					this.refreshData();	  
				}
			}, this.timeInterval);
			this.interval = interval;
		}
	},
	beforeDestroy() {
		// console.log("Dashboard::beforeDestroy() - ");
		clearInterval(this.interval);
	},
	props: {
		diaryCount: [Number, Number],
		correspondenceCount: [Number, Number],
		gradesCount: [Number, Number],
		selectedStudentId: [String, Number],
	},
  methods: {
	refreshData() {
		// Samee - Check to see if user info exists in local storage
		const user = getStorageData('user');
		// console.log("refreshData() called - Dashboard view - user info fetched: ", user);
		
		if(user != null) {
			let tmpLastId = 0; // this.lastNotificationId != null ? this.lastNotificationId : 0;
			
			const year = 2021;
			// Fetch dashboard info
			getAPI("notificationsList", user["accessToken"], {"year": year, "userId": user['id'], "limit": this.limit, "offset": this.offset}).then(response => {
				// this.audio = new Audio('http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3');
				this.loading = false;
				let data = JSON.parse(JSON.stringify(response.data));
				// console.log("dashboard response: ", data);
				// if accessToken has expired, return to login page
				if(response['error'] != null) {
					this.$router.replace("/login");
				} else {
					this.$emit('dashboard-loaded', data);
				} 
			});
		} else {
			this.$router.replace("/login");
		}
	}
  },
  mounted() {
    /*setTimeout(() => {
      this.loading = false;
    }, 1000);*/
  },
});
